module.exports = __webpack_public_path__ + "static/img/20018 (3).f0cdf7f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20018 (3).webp
// module id = j//x
// module chunks = 14